// Packages
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import minMax from 'dayjs/plugin/minMax';
import { BrowserRouter as Router } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

// Components
import App from './App';

// Contexts
import { AnalyticsContextProvider } from './contexts/analyticsContext';
import { AuthUserContextProvider } from './contexts/authUserContext';
import { TdcsConfigContextProvider } from './contexts/tdcsConfigContext';
import { AppConfigContextProvider } from './contexts/appConfigContext';
import { AuthSessionContextProvider } from './contexts/authSessionContext';

// Styles
import '@kite/react-kite/dist/react-kite.css';
import '@ent-ui-kit/mountaineer/dist/index.css';
import '@ent-ui-kit/react/style.css';
import './styles/index.scss';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.extend(minMax);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/** @see https://chalk.charter.com/display/ERSPM/FE+App+Loading+Flow */
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Router>
        <AppConfigContextProvider>
          <TdcsConfigContextProvider>
            <AuthSessionContextProvider>
              <AuthUserContextProvider>
                <AnalyticsContextProvider>
                  <App />
                </AnalyticsContextProvider>
              </AuthUserContextProvider>
            </AuthSessionContextProvider>
          </TdcsConfigContextProvider>
        </AppConfigContextProvider>
      </Router>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
